import moment from 'moment'

export const fmt = (n, currency) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(n)

export const fmtDate = iso => (iso ? moment(iso).format('MM/DD/YY') : '—')
